import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageCircle, X, Phone } from 'lucide-react';

const WHATSAPP_NUMBER = '16269890666';
const WECHAT_ID = 'aligcusca';
const WECHAT_QR = 'https://customer-assets.emergentagent.com/job_267435a5-fd0c-44ab-923a-13480a4c7eac/artifacts/oltnjl2y_Image_20260217213149_160_317.jpg';

const ContactWidget = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [showWechatQR, setShowWechatQR] = useState(false);
  const isZh = i18n.language === 'zh';

  return (
    <>
      {/* Floating Button */}
      <div className="fixed bottom-44 right-6 z-50 flex flex-col items-end gap-3 print:hidden">
        {/* Expanded Options */}
        {isOpen && (
          <div className="flex flex-col gap-3 animate-in fade-in slide-in-from-bottom-2 duration-200">
            {/* WhatsApp */}
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(isZh ? '您好，我想咨询ADU建造服务' : 'Hi, I\'d like to inquire about ADU construction services')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white rounded-full pl-4 pr-2 py-2 shadow-lg hover:shadow-xl transition-all duration-300 group border border-gray-100"
              data-testid="whatsapp-btn"
            >
              <span className="text-sm font-medium text-gray-700 whitespace-nowrap">
                {isZh ? 'WhatsApp 咨询' : 'WhatsApp'}
              </span>
              <div className="w-12 h-12 rounded-full bg-[#25D366] flex items-center justify-center group-hover:scale-110 transition-transform">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </div>
            </a>

            {/* WeChat */}
            <button
              onClick={() => setShowWechatQR(true)}
              className="flex items-center gap-3 bg-white rounded-full pl-4 pr-2 py-2 shadow-lg hover:shadow-xl transition-all duration-300 group border border-gray-100"
              data-testid="wechat-btn"
            >
              <span className="text-sm font-medium text-gray-700 whitespace-nowrap">
                {isZh ? '微信咨询' : 'WeChat'}
              </span>
              <div className="w-12 h-12 rounded-full bg-[#07C160] flex items-center justify-center group-hover:scale-110 transition-transform">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 01.598.082l1.584.926a.272.272 0 00.14.045c.134 0 .24-.108.24-.243 0-.06-.024-.12-.04-.178l-.325-1.233a.493.493 0 01.177-.554C23.028 18.443 24 16.706 24 14.792c0-3.313-3.037-5.934-7.062-5.934zm-2.743 3.46c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.981.97-.981zm4.894 0c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.981.969-.981z"/>
                </svg>
              </div>
            </button>

            {/* Phone - expandable */}
            <div className="flex flex-col gap-1">
              {[{l:'SoCal',t:'6268038000',n:'(626) 803-8000'},{l:'NorCal',t:'4089006688',n:'(408) 900-6688'},{l:'San Diego',t:'8589100000',n:'(858) 910-0000'}].map(p=>(
                <a key={p.l} href={`tel:${p.t}`}
                  className="flex items-center gap-3 bg-white rounded-full pl-4 pr-2 py-1.5 shadow-lg hover:shadow-xl transition-all duration-300 group border border-gray-100"
                >
                  <span className="text-xs font-medium text-gray-700 whitespace-nowrap">{p.l}: {p.n}</span>
                  <div className="w-10 h-10 rounded-full bg-red-600 flex items-center justify-center group-hover:scale-110 transition-transform flex-shrink-0">
                    <Phone className="w-5 h-5 text-white" />
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}

        {/* Main Toggle Button */}
        <button
          onClick={() => { setIsOpen(!isOpen); setShowWechatQR(false); }}
          className={`w-16 h-16 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 hover:scale-110 ${
            isOpen ? 'bg-gray-800 rotate-0' : 'bg-red-600 animate-pulse'
          }`}
          data-testid="contact-widget-toggle"
        >
          {isOpen ? (
            <X className="w-7 h-7 text-white" />
          ) : (
            <MessageCircle className="w-7 h-7 text-white" />
          )}
        </button>
      </div>

      {/* WeChat QR Code Modal */}
      {showWechatQR && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] print:hidden" onClick={() => setShowWechatQR(false)}>
          <div className="bg-white rounded-2xl p-6 max-w-sm mx-4 shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="wechat-qr-modal">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-[#07C160] flex items-center justify-center">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 01.598.082l1.584.926a.272.272 0 00.14.045c.134 0 .24-.108.24-.243 0-.06-.024-.12-.04-.178l-.325-1.233a.493.493 0 01.177-.554C23.028 18.443 24 16.706 24 14.792c0-3.313-3.037-5.934-7.062-5.934zm-2.743 3.46c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.981.97-.981zm4.894 0c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.981.969-.981z"/>
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-gray-900">{isZh ? '微信添加好友' : 'Add on WeChat'}</h3>
              </div>
              <button onClick={() => setShowWechatQR(false)} className="text-gray-400 hover:text-gray-600">
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="bg-gray-50 rounded-xl p-4 mb-4">
              <img src={WECHAT_QR} alt="WeChat QR Code" className="w-full rounded-lg" />
            </div>
            
            <div className="text-center">
              <p className="text-sm text-gray-500 mb-1">{isZh ? '微信号' : 'WeChat ID'}</p>
              <p className="text-lg font-bold text-gray-900 select-all">{WECHAT_ID}</p>
              <p className="text-xs text-gray-400 mt-2">{isZh ? '扫描二维码或搜索微信号添加' : 'Scan QR code or search WeChat ID to add'}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ContactWidget;
